export const getAreWeRunningInMobile = (): boolean => {
  return window.innerWidth <= 1000;
};

export const getAreWeGettingCloseToMobile = (): boolean => {
  return window.innerWidth <= 1370;
};

export const getAreWeRunningInMobilePhone = (): boolean => {
  return window.innerWidth <= 425;
};
